import { createTheme } from "@mui/material/styles";

const brand = {
  main: "#4F3CC9",
  light: "#8577E0",
  dark: "#2E1F8F",
  contrastText: "#FFFFFF",
};

const gold = {
  main: "#F5A623",
  light: "#FFC55C",
  dark: "#B9780A",
  contrastText: "#1B1B24",
};

export const getAppTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: brand,
      secondary: gold,
      success: { main: "#2FB673" },
      background:
        mode === "dark"
          ? { default: "#121218", paper: "#1B1B24" }
          : { default: "#F7F7FB", paper: "#FFFFFF" },
    },
    typography: {
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      h4: { fontWeight: 700 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 600 },
      button: { textTransform: "none", fontWeight: 600 },
    },
    shape: { borderRadius: 14 },
    components: {
      MuiAppBar: {
        defaultProps: { elevation: 0 },
        styleOverrides: { root: { backgroundImage: "none" } },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } },
      },
      MuiButton: {
        styleOverrides: { root: { borderRadius: 10 } },
      },
    },
  });
